import React from 'react';
import { FeatureQuizView } from './FeatureQuiz.view';
import { useQuery } from '@apollo/client';
import { useRefetchData } from '../../../../helpers/refetch/refetchData';
import { LoadingContainer } from 'components/molecules/Loaders/LoadingContainer';
import { GraphQLError } from 'graphql';
import { ErrorContainer } from 'components/organisms/Error/ErrorContainer';
import { GET_PROF_DASHBOARD } from '../../../../graphql/query/dashboardProf/dashboardQuery';
import { GetProfDashboardQuery } from '../../../../graphql/generated/graphql';
import GET_ALL_AVAILABLE_QUIZ from '../../../../graphql/query/quiz/allQuiz';
import { AllQuizzQuery } from '../../../../graphql/generated/graphql';
import { useHistory } from 'react-router-dom';
import { getGoToPage } from 'helpers/page/goToPage';
import pages from 'routes/pages';
import { getElevesDashboardProfFromQuery } from '../../../../helpers/transformApiResponse/classe';

export const FeatureQuiz = () => {
  const history = useHistory();
  const profDashboard = useQuery<GetProfDashboardQuery>(GET_PROF_DASHBOARD);
  useRefetchData(profDashboard.refetch);
  const allQuiz = useQuery<AllQuizzQuery>(GET_ALL_AVAILABLE_QUIZ);

  if (profDashboard.loading || allQuiz.loading)
    return (
      <>
        <LoadingContainer variant="actuQuiz" />
      </>
    );
  if (profDashboard.error)
    return (
      <ErrorContainer
        detailErr={
          new GraphQLError(
            'Erreur dans la récupération des données (ProfDashboard)'
          )
        }
        needCaptureError={false}
      />
    );

  if (allQuiz.error)
    return (
      <ErrorContainer
        detailErr={
          new GraphQLError('Erreur dans la récupération des données (allQuiz)')
        }
      />
    );
  if (!allQuiz.data.availableQuiz) return null;

  const users = profDashboard.data.getProfDashboard.classe.users.map(u =>
    getElevesDashboardProfFromQuery(u)
  );

  const quizzesValue = allQuiz.data.availableQuiz.filter(
    quiz => quiz.debut.slice(0, 10) <= new Date().toJSON().slice(0, 10)
  );

  return (
    <FeatureQuizView
      onClick={(quizID: string) =>
        getGoToPage(history)(pages.RECAP_QUIZ_CLASSE_PAGE.path)({
          id: quizID,
          classeId: profDashboard.data?.getProfDashboard.classe.id
        })
      }
      quizzes={quizzesValue}
      eleves={users}
    />
  );
};
